module.exports = __webpack_public_path__ + "static/images/game-logo.f68a456.png";